namespace Matrix.DataAudit {
    export class AccountHistoryColumns {
        static columnsKey = 'DataAudit.AccountHistory';
    }
}
